import { render, staticRenderFns } from "./Openphish.vue?vue&type=template&id=19cd40b5&"
import script from "./Openphish.vue?vue&type=script&lang=js&"
export * from "./Openphish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports